// Single definition of how a menu becomes spreadsheet rows (the "Menu" and
// "Prices" sheets of the Menu Excel export). Used by handleExportMenuExcel
// (utils/exportExcel.js). The backend keeps an equivalent copy in
// lud-backend/utils/menuExcelExport.js, which builds the Excel attached by
// "Send Items to App"; lud-backend/test/menuExcelExport.test.js fails when the
// two drift apart. This file has no imports so that test can load it as is.

export const MENU_EXPORT_COLUMNS = ["section_ar", "section_en", "item_ar", "item_en", "desc_ar", "desc_en", "image", "allergen_ar", "allergen_en", "callories", "cost", "additions_title_ar", "additions_title_en", "additions_min_max", "additions_mandatory", "addition_name_ar", "addition_name_en", "addition_cost"];

// menu: the menu as returned by the menu API (sections -> items, additionGroups
// carrying their populated `addition`). Returns { rows, priceRows, merges };
// merges use 0-based sheet coordinates, row 0 being the header row.
export function buildMenuExportRows(menu) {
  const rows = [];
  const priceRows = [];
  const merges = [];
  let rowIndex = 1;
  const mergeColumns = (start, end, columns) => {
    if (end - start > 1) columns.forEach((c) => merges.push({ s: { r: start, c }, e: { r: end - 1, c } }));
  };
  const defaultPrice = (item) => {
    const pricing = item.pricing || [];
    return (pricing.find((p) => p.name === "base") || pricing[0])?.price ?? "";
  };

  for (const section of menu.sections || []) {
    const sectionStart = rowIndex;
    for (const item of section.items || []) {
      const itemStart = rowIndex;
      const base = {
        section_ar: section.name?.ar || "",
        section_en: section.name?.en || "",
        item_ar: item.name?.ar || "",
        item_en: item.name?.en || "",
        desc_ar: item.description?.ar || "",
        desc_en: item.description?.en || "",
        image: item.image || "",
        allergen_ar: item.allergens?.ar || "",
        allergen_en: item.allergens?.en || "",
        callories: item.calories?.en || item.calories?.ar || "",
        cost: defaultPrice(item),
      };
      for (const entry of item.pricing || []) {
        priceRows.push({ section_en: base.section_en, item_ar: base.item_ar, item_en: base.item_en, price_name: entry.name, price: entry.price, discount_type: entry.discount?.type || "", discount_value: entry.discount?.value ?? "", effective_price: entry.effectivePrice ?? "" });
      }
      const groups = (item.additionGroups || []).filter((group) => group.addition && !group.addition.missing);
      if (!groups.length) {
        rows.push({ ...base, additions_title_ar: "", additions_title_en: "", additions_min_max: "", additions_mandatory: "", addition_name_ar: "", addition_name_en: "", addition_cost: "" });
        rowIndex++;
      }
      for (const group of groups) {
        const add = group.addition;
        const additionStart = rowIndex;
        const head = { additions_title_ar: add.title?.ar || "", additions_title_en: add.title?.en || "", additions_min_max: `${add.min}-${add.max}`, additions_mandatory: add.isMandatory ? "Yes" : "No" };
        const options = add.options?.length ? add.options : [null];
        for (const option of options) {
          rows.push({ ...base, ...head, addition_name_ar: option?.name?.ar || "", addition_name_en: option?.name?.en || "", addition_cost: option ? option.price : "" });
          rowIndex++;
        }
        mergeColumns(additionStart, rowIndex, [11, 12, 13, 14]);
      }
      mergeColumns(itemStart, rowIndex, [2, 3, 4, 5, 6, 7, 8, 9, 10]);
    }
    mergeColumns(sectionStart, rowIndex, [0, 1]);
  }
  return { rows, priceRows, merges };
}
